import React, { FC } from 'react';
import styled from 'styled-components';
import { formatter } from 'components/atoms/input-duration';
import { Props } from './components';
import { Progress } from './progress';

const CellProgress = styled(Progress).attrs({
  width: 80,
  height: 8,
})`
  margin-right: var(--spacing-03);
`;

export const Cell: FC<Props> = ({
  projectHours: { total_minutes, budget_hours },
}) => {
  return (
    <>
      <CellProgress total_minutes={total_minutes} budget_hours={budget_hours} />
      <span>{formatter(total_minutes)}</span>
    </>
  );
};
